import React from 'react';
import { list } from './styles.mod.scss';

export default function FilterOptionList({ children }) {
  return <ul className={list}>{children}</ul>;
}
